import React, { useRef } from 'react';

function FileDropZone({ onFilesSelected, accept = 'image/*', maxFiles = 5, multiple = true }) {
  const inputRef = useRef(null);

  const handleFileInput = (e) => {
    const files = Array.from(e.target.files);
    const selectedFiles = multiple ? files.slice(0, maxFiles) : files.slice(0, 1);
    if (selectedFiles.length > 0) {
      onFilesSelected(selectedFiles);
    }
  };

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleFileInput}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        onClick={() => inputRef.current.click()}
        style={{
          width: '100%',
          padding: '13px 16px',
          border: '2px dashed var(--primary)',
          borderRadius: 'var(--radius-button)',
          background: 'var(--bg-primary, #f0f4ff)',
          color: 'var(--primary)',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          textAlign: 'center',
          transition: 'background 150ms ease, box-shadow 150ms ease',
          boxShadow: 'none',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'var(--primary-light, #dde8ff)'; e.currentTarget.style.boxShadow = '0 0 0 3px var(--primary-alpha, rgba(79,112,245,0.15))'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg-primary, #f0f4ff)'; e.currentTarget.style.boxShadow = 'none'; }}
      >
        📎 Haz clic para seleccionar las imágenes {multiple ? `(máximo ${maxFiles})` : '(1 imagen)'}
      </button>
    </div>
  );
}

export default FileDropZone;
